import React, {Component} from 'react';

export default class StaticCard extends Component {
    render() {
        const {position, digit} = this.props;

        return (
            <div className={`${position} font-bold`}>
                <span>{digit}</span>
            </div>
        );
    }
}
